import CTA from '~/constants/appearance'

function getButtonStyle (value) {
  if(value) {
    if (value.endsWith(CTA.OUTLINE)) {
      return 'outline'
    }
    if (value.endsWith(CTA.LINK)) {
      return 'naked'
    }
  }
  return null
}

export default getButtonStyle
